import { Box, Text, Stack } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import type { CalendarEvent } from 'src/meetings/models';
import { getAllClientParticipants } from '../utils/event-utils';
import { ClientDetailsCard } from './ClientDetailsCard';
import { MeetingAgendaCard } from './MeetingAgendaCard';
import { MissingClientCard } from './MissingClientCard';

type Props = {
  event: CalendarEvent;
};

export const PreMeetingInformation = ({ event }: Props) => {
  const clientParticipants = getAllClientParticipants(event);

  return (
    <>
      <Box mb="lg" style={{ borderBottom: '1px solid #E5E5E5' }} />

      <Text size="xl" fw={FONT_WEIGHTS.semibold} c="gray.10" mb="lg">
        Meeting preparation
      </Text>

      <Stack gap="lg">
        {clientParticipants.length > 0 ? (
          <>
            <ClientDetailsCard event={event} />
            <MeetingAgendaCard event={event} />
          </>
        ) : (
          <MissingClientCard />
        )}
      </Stack>
    </>
  );
};
